<template>
  <v-dialog v-model="dialogEditShow" max-width="400px">
    <v-card class="pa-4 pa-sm-8">
      <v-btn class="button-close ma-4" icon @click="okClicked()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <h3 v-if="title" class="text-center">{{title}}</h3>
      <div :class="{'text-center': centerText}" class="mt-5" v-html="safeText"></div>
      <div class="row mt-4 justify-center">
        <v-btn v-if="textOk" class="my-4" color="primary" @click="okClicked"> {{ textOk }} </v-btn>
        <v-btn v-else class="my-6" icon @click="okClicked"> <img src="@/assets/images/ai-expert/ok.svg"> </v-btn>
       </div>
    </v-card>
  </v-dialog>
</template>
<script>
/*eslint-disable*/
  import { sanitizeBrHtml } from '@/common/util';
  export default {
  model: {
     prop: 'value',
     event: 'input'
  },
  props: {
    value: Boolean,
    text: {
      type: String,
      default: ""
    },
    textOk: {
      type: String,
      default: ""
    },
    title: String,
    centerText: Boolean,
  },
  data: () => ({
  }),
  watch: {
    async dialogEditShow(newVal) {
      if (newVal) {
      }
    }
  },
  computed: {
    dialogEditShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', false);
      }
    },
    safeText() {
      return sanitizeBrHtml(this.text);
    },
  },
  methods: {
    okClicked() {
      this.$emit('ok');
      this.dialogEditShow = false
    }
  }
};
</script>


